<template>
  <span class="currencyamount">
    <span class="currency">{{ currency }}</span>
    <span class="amount">{{ formatNumber(amount / 100) }}</span>
  </span>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      currency: { type: String, default: undefined },
      amount: { type: Number, default: undefined },
    },
    methods: {
      formatNumber(amount: number) {
        return this.$format.number(amount, {
          notation: 'standard',
          compactDisplay: 'long',
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
      },
    },
  });

</script>
<style lang="css" scoped>
.amount {
  padding-left: 2px;
}
</style>
